'use client';
import cx from 'classnames';
import { MonitorFE, getDirValue, isApp, isPC } from '@spot-fe/utils';
import { GTMScript } from '../gtm-script';
import { UserInfoProvider } from '../provider';
import { LayoutContainer } from './container';
import { PropsWithChildren } from 'react';
import { MonitorScript } from '../monitor-script';
import StyledComponentsRegistry from './antdRegistry.tsx';
import { AdaptH5Script } from '../adaptH5-script';
import { GetLang } from '../getlang';
import { GetCompliance } from '../getCompliance';

import './style.scss';
import { DataCoreScript } from '../data-core-script';
import DispatchClickScript from '../dispatch-click-script';

export interface LayoutProps extends PropsWithChildren {
  hasLoadJsBridge?: boolean; // 是否加载JsBridge 默认加载
  hasLoadUniFrame?: boolean; // 是否加载UniFrame 默认加载
  hasRenderHeader?: boolean; // 是否渲染uniframe的头部，默认渲染（前提条件是加载了UniFrame）
  hasRenderFooter?: boolean; // 是否渲染uniframe的尾部，默认渲染（前提条件是加载了UniFrame）
  hasLoadAppsFlyers?: boolean; // 是否加载 Appsflyer默认加载
  hasLoadAdaBot?: boolean; // 是否加载 AdaBot
  hasLoadComplianceWhiteList?: boolean; // 是否加载合规站合规币白名单
  hasLoadComplianceSDK?: boolean; // 是否加载合规sdk
  hasLoadDispatchClick?: boolean;
  locale: string;
  monitorId?: number;
  projectName?: string;
  env: {
    BASE_ENV: string;
  };
  className?: string;
}

// init monitor
MonitorFE.init();

export function BaseLayout(props: LayoutProps) {
  const {
    hasLoadJsBridge = false,
    hasLoadUniFrame = true,
    hasRenderHeader = true,
    hasRenderFooter = true,
    hasLoadAppsFlyers = true,
    hasLoadAdaBot = true,
    hasLoadComplianceWhiteList = false,
    hasLoadComplianceSDK = false,
    hasLoadDispatchClick = false,
    locale = '',
    monitorId,
    className = ''
  } = props || {};

  const dirValue = getDirValue(locale);

  return (
    <html lang={locale} dir={dirValue} className={className}>
      <head>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        {monitorId && <MonitorScript id={monitorId} />}
        {hasLoadComplianceWhiteList && <GetLang /> }
        {hasLoadComplianceSDK && <GetCompliance /> }
        <DataCoreScript projectName={props.projectName} projectNested={false} />
        {/* PC映射H5 */}
        <AdaptH5Script locale={locale} />
        {hasLoadDispatchClick && <DispatchClickScript />}
      </head>
      <body>
        <div id="__bybit_uniframe_header__"></div>
        <div id="root-placeholder" className="root-placeholder">
          <UserInfoProvider>
            <LayoutContainer
              {...props}
              hasLoadJsBridge={hasLoadJsBridge}
              hasLoadUniFrame={hasLoadUniFrame}
              hasRenderHeader={hasRenderHeader}
              hasRenderFooter={hasRenderFooter}
              hasLoadAppsFlyers={hasLoadAppsFlyers}
              hasLoadAdaBot={hasLoadAdaBot}
            >
              <StyledComponentsRegistry>
                {props.children}
                {/* {InspectorWrapper(props.children)} */}
              </StyledComponentsRegistry>
            </LayoutContainer>
          </UserInfoProvider>
        </div>
        <div id="__bybit_uniframe_footer__"></div>
        <GTMScript />
      </body>
    </html>
  );
}
